import { useState } from "react";
import styles from "./style.module.scss";
import PropType from "prop-types";
import { Row, Col } from "antd";

const Header = ({publishActive, onPublish}) => {

  return (
      <Row justify="space-between" align="top">
        <Col span={12}>
        </Col>
        <Col span={12}>
          <div className={`${styles.genericButton}`}>
            <div>
              <button
                className={`${styles.button} ${!publishActive ? styles.publish : ''}`}
                disabled={!publishActive}
                onClick={onPublish}
              >
                Publish
              </button>
            </div>
          </div>
        </Col>
      </Row>
  );
};

Header.propTypes = {
  publishActive: PropType.bool,
  onPublish: PropType.func,
};

Header.defaultProps = {
  publishActive: false,
  onPublish: () =>{
  }
}

export default Header;
